import {initDebugger} from "../støttefunksjoner/debug";
import {Injectable} from "@angular/core";

const debug = initDebugger('LokaltDatalager');

/**
 * Wrapper rundt {@link window#localStorage}.
 *
 * Migrert fra ajs lederplan-klient/src/scripts/felles/tjenester/LokaltDatalager.ts
 * Merk at vi per nå ikke har impl støtte for bruk av $cordovaNativeStorage ved kjøring i cordova.
 *
 * Promise-apiet er beholdt for fremtidig kompatibilitet med $cordovaNativeStorage.
 */
@Injectable({providedIn: 'root'})
export class LokaltDatalager {

    static regNavn = 'LokaltDatalager';
    static nøkkelprefiks = 'lederplan.';

    constructor() {
    }

    private datalager = Promise.resolve(window.localStorage);

    //offentlige metoder

    async eksisterer(nøkkel: string): Promise<boolean> {
        const verdi = await this.hent(nøkkel);
        return verdi !== null;
    }

    async lagre(nøkkel: string, verdi: string): Promise<any> {
        (await this.hentDatalager()).setItem(this.medPrefiks(nøkkel), verdi);
        debug(`lagret ${nøkkel}`, verdi);
    }

    async lagreBoolsk(nøkkel: string, verdi: boolean): Promise<any> {
        await this.lagre(nøkkel,`${verdi}` );
    }

    async hent(nøkkel: string): Promise<string | null> {
        return (await this.hentDatalager()).getItem(this.medPrefiks(nøkkel));
    }

    /** returnerer boolsk verdi. Merk at vi returnerer false dersom nøkkel ikke eksisterer. */
    async hentBoolsk(nøkkel: string): Promise<boolean> {
        return (await this.hent(nøkkel)) === 'true';
    }

    async hentEllerStandardVerdi(nøkkel: string, standardVerdi: string): Promise<string> {
        return (await this.hent(nøkkel)) ?? standardVerdi;
    }

    async slett(nøkkel: string): Promise<any> {
        const lager = await this.hentDatalager();
        const nøkkelMedPrefiks = this.medPrefiks(nøkkel);
        debug(`slettet ${nøkkel}`, lager.getItem(nøkkelMedPrefiks));
        lager.removeItem(nøkkelMedPrefiks);
    }

    //hjelpemetoder

    private medPrefiks(nøkkel: string) {
        return LokaltDatalager.nøkkelprefiks + nøkkel;
    }

    protected hentDatalager(): Promise<Storage> {
        return this.datalager;
    }
}

